import { render, staticRenderFns } from "./customer-info.vue?vue&type=template&id=2fd0fb28&scoped=true"
import script from "./customer-info.vue?vue&type=script&lang=js"
export * from "./customer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0fb28",
  null
  
)

export default component.exports